import { Button } from "@-/dev.improve.haniverse.components.ui.button";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { MorphemeMnemonicsPanelContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content._context";

/**
 * "Add Mnemonic" pill. Lives under the absent-mnemonic fallback copy and starts the same
 * in-place editor the toolbar edit action uses, seeded with the generated formula.
 */
export function MnemonicSuggestionButton() {
  const [setIsEditing] = useContextSelectors(MorphemeMnemonicsPanelContext, (c) => c.setIsEditing);

  return (
    <Button
      className="h-8 self-start rounded-full px-4 py-0"
      onPress={() => {
        setIsEditing(true);
      }}
      testID="add-mnemonic-button"
      variant="outline"
    >
      <Text className="text-sm leading-5">Add Mnemonic</Text>
    </Button>
  );
}
